import { Model } from "@/models/base/model";

export class UserArticleLike extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // コンテンツ記事いいね更新
  async updateUserArticleLikes(
    articleId: number,
    is_liked: boolean
  ): Promise<any> {
    this.url = "/cms/api/users/article-likes/update";
    this.reqParams = { is_liked };
    return await this.save({ articleId }, "POST");
  }
}
